import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";
import { useLanguage } from "@/hooks/useLanguage";

const LoadingStorySection = () => {
  const [messageIndex, setMessageIndex] = useState(0);
  const { language, t } = useLanguage();
  
  const loadingMessages = [
    `✨ ${t('loadingMessages.craftingTheNextChapter')}...`,
    `📖 ${t('loadingMessages.weavingThePlotTwists')}...`,
    `🚀 ${t('loadingMessages.yourAdventureIsAboutToUnfold')}...`,
    `🎭 ${t('loadingMessages.developingTheCharacters')}...`,
    `🌟 ${t('loadingMessages.imaginingNewPossibilities')}...`,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % loadingMessages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [loadingMessages.length]);

  return (
    <div className="w-full space-y-8">
      <Card className="mb-8 bg-white p-8 shadow-lg">
        <div className="prose mx-auto max-w-3xl">
          <div className="space-y-4">
            {/* Animated text placeholder */}
            <motion.div
              initial={{ opacity: 0.3 }}
              animate={{ opacity: 0.7 }}
              transition={{ duration: 1.5, repeat: Infinity, repeatType: "reverse" }}
              className="h-4 bg-gray-200 rounded w-3/4"
            />
            <motion.div
              initial={{ opacity: 0.3 }}
              animate={{ opacity: 0.7 }}
              transition={{ duration: 1.5, repeat: Infinity, repeatType: "reverse", delay: 0.2 }}
              className="h-4 bg-gray-200 rounded w-full"
            />
            <motion.div
              initial={{ opacity: 0.3 }}
              animate={{ opacity: 0.7 }}
              transition={{ duration: 1.5, repeat: Infinity, repeatType: "reverse", delay: 0.4 }}
              className="h-4 bg-gray-200 rounded w-5/6"
            />
          </div>

          {/* Loading message */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            key={messageIndex}
            className="mt-8 text-center text-primary font-medium"
          >
            {loadingMessages[messageIndex]}
          </motion.p>

          {/* AI suggestions placeholders */}
          <div className="mt-6 grid gap-4 md:grid-cols-3">
            {[1, 2, 3].map((i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0.3 }}
                animate={{ opacity: 0.7 }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  repeatType: "reverse",
                  delay: i * 0.2,
                }}
                className="h-24 bg-gray-100 rounded-lg border-2 border-gray-200"
              />
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default LoadingStorySection;
